import {handleTryPremiumContentClick} from './module_common';

import {
    attachUpdateArticleCardFavourite,
    attachUpdateArticleCardMobileFavourite,
    addClass,
    removeClass,
} from './module_toggle_favourite';

import {
    configPlayerCard,
    attachArticleCardPlayerBtn,
} from './module_player-card';

import { lockSelector } from './module_common_selector';

import { openModal } from './module_modal';

import { openSignInModal } from './module_auth_helper';

const mobileActionsSelector = '.mobile-article-actions-attach-clk';

const attachLockClick = function(){
    $(lockSelector).on('click', function(e){
        e.preventDefault();
        if (!UIDg){
            openSignInModal()
        }else{
            handleTryPremiumContentClick(window.location.href)
        }
    })
}

const attachMobileActionClick = function(){
    $(mobileActionsSelector).on('click', function(e){
        e.preventDefault();
        if (!UIDg){
            openSignInModal()
        }
        const el = $(e.currentTarget)
        
        const modalSelector = '#mobile-article-card-actions-mod'
        const modalEl = $(modalSelector)
        const titleEl = modalEl.find(".card-action-title")
        titleEl.text(el.data('title'))

        const podcastEl = modalEl.find(".card-action-podcast-title")
        podcastEl.text(el.data('podcast'))

        const imgEl = modalEl.find(".card-action-img")
        imgEl.attr('src', el.data('img'))

        const status = el.data('status')
        const elementId = el.data('elid')
        const addFavEl = modalEl.find(".add-to-fav-mobile")
        addFavEl.data('elementid', elementId)
        if (status == 0){
            addFavEl.removeClass(removeClass)
            addFavEl.addClass(addClass)
        }else{
            addFavEl.addClass(removeClass)
            addFavEl.removeClass(addClass)
        }
        
        openModal(modalSelector, "attachMobileActionClick")
    })
}

export const configArticleCard = function(){
    attachLockClick()
    attachMobileActionClick()

    configPlayerCard()
    attachArticleCardPlayerBtn()

    attachUpdateArticleCardFavourite()
    attachUpdateArticleCardMobileFavourite()
}